import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';

export function TABLE__loading() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  return <div className="w-full h-full flex-1 bg-component flex items-center justify-center min-h-[50px]">Loading...</div>;
}
